import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { reducersNames } from 'constants/reducers';

interface FavoriteState {
  favorites: Record<string, boolean>;
}

const initialState: FavoriteState = {
  favorites: {},
};

export const favoriteSlice = createSlice({
  name: reducersNames.FAVORITES,
  initialState,
  reducers: {
    setFavorites: (state, action: PayloadAction<Record<string, boolean>>) => {
      state.favorites = action.payload;
    },
    toggleFavorite: (
      state,
      action: PayloadAction<{ value: string; isFavorite: boolean }>
    ) => {
      const { value, isFavorite } = action.payload;

      state.favorites[value] = isFavorite;
    },
  },
});

export const { setFavorites, toggleFavorite } = favoriteSlice.actions;
